import React from 'react';
import '../styles/Footer.css';
import Insta from '../assets/images/instaLogo.webp';
import InstaFallback from '../assets/images/instaLogo.png';
import Vinted from '../assets/images/logoVinted.webp';
import VintedFallback from '../assets/images/logoVinted.png';
import Gmail from '../assets/images/gmailLogo.webp';
import GmailFallback from '../assets/images/gmailLogo.png';
import Twitch from '../assets/images/twitchLogo.webp';
import TwitchFallback from '../assets/images/twitchLogo.png';
import { useLanguage } from '../i18n/LanguageContext';
import Picture from './Picture';

const Footer = () => {
    const { t } = useLanguage();

    return (
        <footer className='site-footer'>
            <div className='footer-inner'>
                <div className='footer-brand'>
                    <p className='eyebrow'>{t('brand.title')}</p>
                    <h3>{t('footer.headline')}</h3>
                    <p className='footer-note'>
                        {t('footer.note')}
                    </p>
                </div>
                <div className='footer-links'>
                    <a
                        target='_blank'
                        href='https://www.instagram.com/maf_industrie/'
                        rel='noreferrer'
                    >
                        <Picture
                            webpSrc={Insta}
                            fallbackSrc={InstaFallback}
                            alt='Instagram'
                        />
                        @maf_industrie
                    </a>
                    <a
                        target='_blank'
                        href='https://www.vinted.fr/member/82496574'
                        rel='noreferrer'
                    >
                        <Picture
                            webpSrc={Vinted}
                            fallbackSrc={VintedFallback}
                            alt='Vinted'
                        />
                        {t('footer.shop')}
                    </a>
                    <a href='mailto:lucasmafrica57@gmail.com'>
                        <Picture
                            webpSrc={Gmail}
                            fallbackSrc={GmailFallback}
                            alt='Email'
                        />
                        lucasmafrica57@gmail.com
                    </a>
                    <a
                        target='_blank'
                        href='https://www.twitch.tv/maf_5'
                        rel='noreferrer'
                    >
                        <Picture
                            webpSrc={Twitch}
                            fallbackSrc={TwitchFallback}
                            alt='Twitch'
                        />
                        twitch.tv/maf_5
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
